import { Img } from '#src/atoms/ui/Img/index.tsx';
import type { Pictures } from '#src/components/landing/types.ts';

type Props = {
  alt?: string;
  className?: string;
  picture: Pictures;
  height?: number;
  width?: number;
};

export const Picture = ({ className, picture, alt, height, width }: Props) => {
  return (
    <picture className={className}>
      {!!picture.avif && <source srcSet={picture.avif} type="image/avif" />}
      <Img src={picture.pictureUrl} alt={alt} height={height} width={width} />
    </picture>
  );
};
